<template lang="pug">
  ul.dropdown-menu
    li.dropdown-menu__item
      .dropdown-menu__link(
        @click="onRelocateToProfile()"
      ) Личный кабинет
    li.dropdown-menu__item(
      @click="onLogOut()"
    )
      router-link.dropdown-menu__link(
        to="/"
      ) Выйти
</template>

<script>
import {mapMutations, mapState} from "vuex";
import {RoleEnums} from "../../../const/index.js";

export default {
  name: "UserDropdown",
  computed: {
    ...mapState(["userData"])
  },
  methods: {
    ...mapMutations(["removeToken"]),
    onRelocateToProfile() {
      if (this.userData.role === RoleEnums.ADMIN) {
        this.$router.push({name: "Admin"});
      } else if (this.userData.role === RoleEnums.DIRECTOR) {
        this.$router.push({name: "Manager"});
      } else if (this.userData.role === RoleEnums.PARENT) {
        this.$router.push({name: "Profile"});
      } else {
        alert("WRONG ROLE");
      }
      // if (this.userData.role === 6) {
      //   this.$router.push({ name: "Profile" });
      // } else if (this.userData.role === 3) {
      //   this.$router.push({ name: "OperatorRequests" });
      // } else {
      //   alert("WRONG USER ROLE");
      // }
    },
    onBodyClick() {
      this.$emit("close");
    },
    onLogOut() {
      this.removeToken();
    }
  },
  created() {
    document.body.addEventListener("click", this.onBodyClick);
  },
  beforeDestroy() {
    document.body.removeEventListener("click", this.onBodyClick);
  }
};
</script>
